import { render, staticRenderFns } from "./selectzf.vue?vue&type=template&id=f3b002f4&scoped=true&"
import script from "./selectzf.vue?vue&type=script&lang=js&"
export * from "./selectzf.vue?vue&type=script&lang=js&"
import style0 from "./selectzf.vue?vue&type=style&index=0&id=f3b002f4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3b002f4",
  null
  
)

export default component.exports